export class EventParticipantState {
  constructor(
    public readonly totalRegistered: number,
    public readonly maxParticipants: number,
    public readonly totalWaitingApproove: number,
  ) {}
}
